export const Types = {
  FILE_OPERATION_REQUESTED: "jobRequest/FILE_OPERATION_REQUESTED",
  FILE_OPERATION_FAILURE: "jobRequest/FILE_OPERATION_REQUESTED",
  FILE_PERMANENT_UPLOAD_SUCCESS: "jobRequest/FILE_PERMANENT_UPLOAD_SUCCESS"
};
